// Module
var code = "<div layout=\"column\"> <md-tooltip md-delay=\"250\"> {{$ctrl.type | translate}} </md-tooltip> <md-icon md-svg-icon=\"{{$ctrl.type}}\" class=\"requirement-icons\"></md-icon> </div> ";
// Exports
export default code;